import { ChainId } from '@nominex/nomiswap-sdk'
import addresses from 'config/constants/contracts'
import { getPoolsConfig, MAIN_POOL_ID } from 'config/pools'

const poolsConfig = getPoolsConfig(ChainId.BSC)
const launchpool = poolsConfig.find(({ sousId }) => sousId === MAIN_POOL_ID)

export const getAddress = (address: Record<ChainId, string>, chainId?: number): string =>
  address[chainId] ? address[chainId] : address[ChainId.BSC]

export const getMulticallAddress = (chainId: ChainId) => getAddress(addresses.multicall, chainId)

export const getFarmingHelperAddress = (chainId: ChainId) => getAddress(addresses.farmingHelper, chainId)

export const getNomiswapEPCSFactoryAddress = (chainId: ChainId) => getAddress(addresses.nomiswapEPCSFactory, chainId)

export const getNomiswapEPCSRouterAddress = (chainId: ChainId) => getAddress(addresses.nomiswapEPCSRouter, chainId)

export const getReinvestAddress = () => getAddress(addresses.reinvest)

export const getPoolFactoryAddress = () => getAddress(addresses.poolFactory)

export const getStableSwapMigratorAddress = () => getAddress(addresses.stableSwapMigrator)

export const getLaunchpoolMigratorAddress = () => launchpool.migratorAddress

export const addressesEqual = (address1: string, address2: string) => address1.toLowerCase() === address2.toLowerCase()
